import React, { useState } from 'react';
import { Button } from '@quantiix/design-system';
import { useTranslation } from '../../../i18n';
import { useToast } from '../../../contexts/ToastContext';
import { createLogger } from '../../../utils/logger';
import shared from '../Settings.shared.module.css';
import styles from './EventsSection.module.css';

const logger = createLogger('Shell::Settings::Events');

const NOTIFICATION_CHANNELS = [
    { id: 'app',   labelKey: 'settings.events.notificationTypes.app',   defaultEnabled: true  },
    { id: 'sms',   labelKey: 'settings.events.notificationTypes.sms',   defaultEnabled: false },
    { id: 'email', labelKey: 'settings.events.notificationTypes.email', defaultEnabled: false }
];

function EventsSection() {
    const { t } = useTranslation('shell');
    const { addToast } = useToast();

    const [channels, setChannels] = useState(() =>
        Object.fromEntries(NOTIFICATION_CHANNELS.map(c => [c.id, c.defaultEnabled]))
    );

    const toggleChannel = (id) => {
        setChannels(prev => ({ ...prev, [id]: !prev[id] }));
    };

    const handleAddSchedule = () => {
        // TODO: open the Do-Not-Disturb schedule editor modal once design lands.
        // Until then, surface a toast so we can wire the click without leaving dead UI.
        logger.info('Add schedule clicked');
        addToast({
            type: 'info',
            message: t('settings.events.dnd.addScheduleStub'),
            duration: 3000
        });
    };

    return (
        <div className={shared.sectionContent}>
            <div className={shared.block}>
                <h3 className={shared.sectionTitle}>{t('settings.events.title')}</h3>
                <p className={shared.description}>{t('settings.events.description')}</p>
            </div>

            <div className={shared.block}>
                <h3 className={shared.sectionTitle}>{t('settings.events.notificationTypes.title')}</h3>
                <p className={shared.description}>{t('settings.events.notificationTypes.description')}</p>

                <div className={styles.checkboxGroupLabel}>
                    {t('settings.events.notificationTypes.label')}
                </div>
                <ul className={styles.checkboxList}>
                    {NOTIFICATION_CHANNELS.map(channel => (
                        <li key={channel.id} className={styles.checkboxItem}>
                            <label className={styles.checkboxLabel}>
                                <input
                                    type="checkbox"
                                    className={styles.checkbox}
                                    checked={channels[channel.id]}
                                    onChange={() => toggleChannel(channel.id)}
                                />
                                <span>{t(channel.labelKey)}</span>
                            </label>
                        </li>
                    ))}
                </ul>
            </div>

            <div className={shared.block}>
                <h3 className={shared.sectionTitle}>{t('settings.events.dnd.title')}</h3>
                <p className={shared.description}>{t('settings.events.dnd.description')}</p>

                <Button variant="primary" onClick={handleAddSchedule}>
                    {t('settings.events.dnd.addSchedule')}
                </Button>
            </div>
        </div>
    );
}

export default EventsSection;